import Token from '@/utils/Token';
import Mask from '@/utils/Mask';

export default {
    parse(data) {
        ['ativo'].forEach(item => {
            data[item] = parseInt(data[item]);
        });

        ['documento'].forEach(item => {
            if(data[item]) {
                if(data.pessoa == 'J') {
                    data[item] = Mask.cnpj(data[item]);
                } else {
                    data[item] = Mask.cpf(data[item]);
                }
            }
        });

        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/log/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/log/list${params}`, Token.getHeader());
    },
    option(table, tableId, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/log/option/${table}/${tableId}${params}`, Token.getHeader());
    },
    listContrato(contrato_id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/log/listContrato/${contrato_id}${params}`, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/log/${id}`, Token.getHeader());
    },
}
